/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Reference_Response_CaptionInputs */

const en_endpoint_reference_response_caption = /** @type {(inputs: Endpoint_Reference_Response_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, one example value per field.`)
};

const zh_hans1_endpoint_reference_response_caption = /** @type {(inputs: Endpoint_Reference_Response_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON，每个字段一个示例值。`)
};

const pt_br2_endpoint_reference_response_caption = /** @type {(inputs: Endpoint_Reference_Response_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, um valor de exemplo por campo.`)
};

const es_endpoint_reference_response_caption = /** @type {(inputs: Endpoint_Reference_Response_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, un valor de ejemplo por campo.`)
};

const fr_endpoint_reference_response_caption = /** @type {(inputs: Endpoint_Reference_Response_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, une valeur d’exemple par champ.`)
};

const de_endpoint_reference_response_caption = /** @type {(inputs: Endpoint_Reference_Response_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, ein Beispielwert pro Feld.`)
};

const ru_endpoint_reference_response_caption = /** @type {(inputs: Endpoint_Reference_Response_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, по одному примеру значения на поле.`)
};

const it_endpoint_reference_response_caption = /** @type {(inputs: Endpoint_Reference_Response_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, un valore di esempio per campo.`)
};

/**
* | output |
* | --- |
* | "JSON, one example value per field." |
*
* @param {Endpoint_Reference_Response_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_reference_response_caption = /** @type {((inputs?: Endpoint_Reference_Response_CaptionInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Reference_Response_CaptionInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_reference_response_caption(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_reference_response_caption(inputs)
	if (locale === "es") return es_endpoint_reference_response_caption(inputs)
	if (locale === "fr") return fr_endpoint_reference_response_caption(inputs)
	if (locale === "de") return de_endpoint_reference_response_caption(inputs)
	if (locale === "ru") return ru_endpoint_reference_response_caption(inputs)
	if (locale === "it") return it_endpoint_reference_response_caption(inputs)
	return en_endpoint_reference_response_caption(inputs)
});